import uuid from "react-native-uuid";
import { create } from "zustand";

type ToastSeverity = "success" | "error" | "warning" | "info";

// Toast structure
interface Toast {
  id: string;
  severity: ToastSeverity;
  message: string;
  duration?: number;
}

export type notifyType = (toast: Omit<Toast, "id">) => void;

interface ToastState {
  toasts: Toast[]; // Active toasts
  notify: notifyType; // Add a toast
  removeToast: (id: string) => void; // Remove a toast by ID
}

export const useToastNotify = create<ToastState>((set) => ({
  toasts: [],

  notify: (toast) => {
    const id = uuid.v4();
    const newToast: Toast = { ...toast, id };
    set((state) => ({ toasts: [...state.toasts, newToast] }));
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },
}));
